import { memo } from "react";
import { Alert, AlertTitle } from "@mui/material";
import { Handshake } from "@mui/icons-material";

/**
 * Aviso fixo da afiliada: deixa claro de QUAL organização são os
 * teleconsultores e horários exibidos na tela.
 */
export const AffiliateProviderBanner = memo(function AffiliateProviderBanner({
  providerName,
}: {
  providerName: string;
}) {
  return (
    <Alert
      severity="info"
      icon={<Handshake />}
      sx={{ position: "sticky", top: 0, zIndex: 1, borderRadius: 2 }}
    >
      <AlertTitle sx={{ fontWeight: 700 }}>Teleconsultoria de {providerName}</AlertTitle>
      Você está vendo os teleconsultores e horários de <strong>{providerName}</strong>,
      organização à qual sua clínica é afiliada.
    </Alert>
  );
});
